import React from 'react';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { hasDeliveryIssue, mapParcelStage, translatedTrackingStage } from '../utils/mapParcelStage';
import { TrackingDetails } from '~/lib/types/tracking-types';
import { IP2GCoreComponentProps } from '@parcel2go/core-ui/dist/types';
import { P2GButton, P2GGrid, P2GText, SvgEnquiryError } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';

export interface ITabLabel extends IP2GCoreComponentProps {
  index: number;
  data: TrackingDetails;
  iconColor: string;
}

export const TabLabel: React.FC<ITabLabel> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  const stage = mapParcelStage(props.data);

  return (
    <P2GGrid container spacing={1} justify="center">
      {hasDeliveryIssue(props.data) && (
        <P2GGrid item>
          <SvgEnquiryError width={20} height={24} fill={props.iconColor} className={'tab-icon'} />
        </P2GGrid>
      )}
      <P2GGrid item>
        <P2GText variant="button" component="span">
          <Trans
            t={t}
            i18nKey="HISTORY_PARCEL_SELECTOR_TAB"
            values={{ number: props.index }}
            defaults="Parcel {{number}}"
          />
        </P2GText>
      </P2GGrid>
      {stage !== 'TRACKING_STAGE_NULL' && (
        <P2GGrid item>
          <P2GText variant="button" component="span">
            {translatedTrackingStage(t, stage)}
          </P2GText>
        </P2GGrid>
      )}
    </P2GGrid>
  );
};

function tabPanelProps(index: number) {
  return {
    id: `p2g-tab-${index}`,
    'aria-controls': `p2g-tabpanel-${index}`
  };
}

export interface ITrackingTabProps extends IP2GCoreComponentProps {
  label: string | React.ReactElement;
  index: number;
  handleTabClick: (value: string) => void;
  parcel: string;
}

export const TrackingTab: React.FC<ITrackingTabProps> = (props) => {
  return (
    <P2GGrid item>
      <P2GButton
        variant="secondary"
        key={props.id}
        onClick={(e) => {
          e.preventDefault();
          props.handleTabClick(props.parcel);
        }}
        classNames={clsx('p2g-tab', props.classNames)}
        {...tabPanelProps(props.index)}
      >
        {props.label}
      </P2GButton>
    </P2GGrid>
  );
};
